import React from 'react';
import { Box, Flex, useBreakpointValue } from '@chakra-ui/react';
import { useLocation } from '@reach/router';
import { useHeaderData } from '@interness/web-core/src/hooks';
import Link from '@interness/web-core/src/components/elements/Link/Link';
import Mounted from '@interness/web-core/src/components/structure/Mounted/Mounted';
import RolexClock from '@interness/web-core/src/components/modules/RolexClock/RolexClock';
import PrimaryMenu from '../PrimaryMenu';
import { jsx as ___EmotionJSX } from "@emotion/react";
const Header = () => {
  const {
    pathname
  } = useLocation();
  const data = useHeaderData();
  const rolexData = data.config.brand_config[0];
  const displayMenu = useBreakpointValue({
    base: 'none',
    md: 'none',
    lg: 'block',
    xl: 'block',
    '2xl': 'block'
  }, {
    fallback: 'md'
  });
  const flexJustifyContent = useBreakpointValue({
    base: 'center',
    md: 'center',
    lg: 'space-between',
    xl: 'space-between',
    '2xl': 'space-between'
  }, {
    fallback: 'md'
  });
  return ___EmotionJSX(Mounted, null, ___EmotionJSX(Flex, {
    h: '120px',
    w: '100%',
    px: ['10px', '10px', '40px', '40px'],
    bgColor: "base.500",
    boxShadow: "md",
    alignItems: "center",
    justifyContent: flexJustifyContent
  }, ___EmotionJSX(Flex, {
    fontSize: "2.5rem",
    fontWeight: "light",
    alignItems: "center"
  }, ___EmotionJSX(Box, null, ___EmotionJSX(Link, {
    to: "/"
  }, ___EmotionJSX("img", {
    style: {
      maxWidth: '100%',
      maxHeight: '80px',
      minHeight: '60px',
      margin: '0'
    },
    src: data.logo.localFile.publicURL,
    alt: data.seo_title,
    title: data.seo_title
  })))), ___EmotionJSX(Box, {
    pl: "30px",
    marginLeft: "auto",
    display: displayMenu
  }, ___EmotionJSX(PrimaryMenu, null)), rolexData && rolexData.rolex_clock && pathname !== '/uhren/longines' && ___EmotionJSX(Box, {
    pl: "15px"
  }, ___EmotionJSX(RolexClock, null))));
};
export default Header;